'use strict';

import type { UserFlowStage } from '../../Entities/User/UserFlowStage';
import { EntityCollection } from '../EntityCollection';

export class UserFlowStageCollection extends EntityCollection<UserFlowStage> {}
